import React from "react";
import { useNavigate } from "react-router";
import { BannerLayoutProps } from "@companion-core/shared/app/Interfaces/blocks";
import { Button } from "@companion-core/shared/app/Components/Button";
import { redirectTo } from "@companion-core/web/src/Utilities/navigation";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { sanitizeHtml } from "@companion-core/shared/app/Utils/htmlSanitizer";
import "@companion-core/web/src/Assets/Styles/scss/blockBanner.scss";

export const BannerLayout = ({
  title,
  subtitle,
  description,
  mediaUrl,
  button,
}: BannerLayoutProps) => {
  const navigate = useNavigate();

  return (
    <section
      className="banner-layout"
      data-testid="block-banner"
      style={
        mediaUrl
          ? {
              backgroundImage: `url("${getCloudinaryOptimizedUrl(mediaUrl, {
                contentType: "banner",
                width: window.innerWidth,
                height: 415,
              })}")`,
            }
          : {}
      }>
      <div data-testid="banner-layout__shadow" className="banner-layout__shadow" />
      <div className="banner-layout__content">
        <p className="body-text-6 banner-layout__title" data-testid="block-banner__title">
          {title}
        </p>
        {subtitle && (
          <p className="super-title-3 banner-layout__subtitle" data-testid="block-banner__subtitle">
            {subtitle}
          </p>
        )}
        {description && (
          <p
            className="banner-layout__description"
            data-testid="block-banner__description"
            // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
          />
        )}
        {button && button.button_title && (
          <Button
            testID="block-banner__cta"
            label={button.button_title}
            type="secondary"
            size="large"
            negative
            classNames={["banner-layout__cta"]}
            onClick={() =>
              redirectTo(button.button_link ?? "/", button?.button_type ?? "internal", navigate)
            }
          />
        )}
      </div>
    </section>
  );
};
